<div
    class="notification notification_{{ data.type }}"
    [ngClass]="{ notification_closing: initiateClose }"
    (animationend)="onAnimationend()"
    (click)="handleClick($event)"
>
    <div class="content">
        <h5 *ngIf="data.showHeadline" class="headline">
            {{ data.messageHeadline ? data.messageHeadline : (data.translationHeadline | translateSafe) }}
        </h5>
        <p class="text" *ngIf="data.messageText" [innerHTML]="data.messageText | safe: 'html'"></p>
        <p class="text" *ngIf="data.translationText">{{ data.translationText | translateSafe }}</p>
        <ng-container *ngIf="data.translationArray as translations">
            <ul *ngIf="translations.length > 1">
                <li *ngFor="let translation of translations">
                    {{ translation | translateSafe }}
                </li>
            </ul>
            <p class="text" *ngIf="translations.length === 1">{{ translations[0] | translateSafe }}</p>
        </ng-container>
        <ng-container *ngIf="data.messageArray as messages">
            <ul *ngIf="messages.length > 1">
                <li *ngFor="let message of messages">
                    {{ message }}
                </li>
            </ul>
            <p class="text" *ngIf="messages.length === 1">{{ messages[0] }}</p>
        </ng-container>
    </div>
    <app-svg-icon aria-hidden="true" iconName="close" class="icon-close"></app-svg-icon>
</div>
